import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils';

export type PatientEventType =
  | 'careplan_renewed'
  | 'doctor_decided_not_to_renew';

type PatientEventPayload = {
  stopped_before_cp_end?: boolean;
};

const patientEventPayloadSchema: Schema<PatientEventPayload> = z.object({
  stopped_before_cp_end: cz.optional(z.boolean()),
});

export type PatientEvent = {
  id: string;
  event_type: PatientEventType;
  created_at: string;
  author_first_name?: string;
  author_last_name?: string;
  author_id?: string;
  payload?: PatientEventPayload;
};

export const patientEventsSchema: Schema<PatientEvent> = z.object({
  id: z.string(),
  event_type: z.literal(['careplan_renewed', 'doctor_decided_not_to_renew']),
  created_at: z.string(),
  author_first_name: cz.optional(z.string()),
  author_last_name: cz.optional(z.string()),
  author_id: cz.optional(z.string()),
  payload: cz.optional(patientEventPayloadSchema),
});
